import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getVerifyAndDeleteBreederSlice = createSlice({
    name: 'VerifyAndDeleteBreeder',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchVerifyAndDeleteBreeder.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchVerifyAndDeleteBreeder.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchVerifyAndDeleteBreeder.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setVerifyAndDeleteBreeder , setStatus} = getVerifyAndDeleteBreederSlice.actions;
export default getVerifyAndDeleteBreederSlice.reducer;

export const fetchVerifyAndDeleteBreeder = createAsyncThunk('/getVerifyAndDeleteBreeder/fetch', async({id}) => {
    const res = await axios.delete(`${window.env.API_URL}/VerifyAndDeleteBreeder/${id}`);
    const VerifyAndDeleteBreederData = res.data;
    return VerifyAndDeleteBreederData.data;
})